module.exports = __webpack_public_path__ + "media/images/front/contents/h1_video-fc22276c650a810a3b3c3a3829218e79.svg";